
import { supabase } from "@/integrations/supabase/client";

/**
 * Checks if the user has already consented to the Microsoft Graph permissions
 * by attempting to acquire a token
 */
export async function hasGraphConsent(): Promise<boolean> {
  try {
    // Get the tenant ID from the current session
    const { data: { session } } = await supabase.auth.getSession();
    const tenant_id = session?.user?.app_metadata?.tenant_id;
    
    if (!tenant_id) {
      return false; // No tenant ID, so consent is needed
    }

    // Try to verify consent using the secure endpoint that doesn't expose tokens
    const { data, error } = await supabase.functions.invoke("graph-token-granted", {
      body: { tenant_id }
    });

    // Return true if we have consent based on the new response format
    return !error && data && data.consent_granted === true;
  } catch (error) {
    console.error("Error checking Graph consent:", error);
    return false;
  }
}

/**
 * Initiates the Microsoft Graph consent flow
 */
export function initiateGraphConsent(tenantId: string | null): void {
  // The actual URL would include the real APP ID and proper redirect URL
    const AZURE_APP_ID = "a9692cf7-0541-42bd-a410-125433a52d62";
    const urlPath = tenantId || 'organizations';
    const redirectUri = encodeURIComponent(window.location.origin + '/mailboxes')
    const scope = "https://graph.microsoft.com/.default";
    const consentUrl = `https://login.microsoftonline.com/${urlPath}/v2.0/adminconsent?client_id=${AZURE_APP_ID}&redirect_uri=${redirectUri}&scope=${scope}`;

    window.location.href = consentUrl;
}
